import { json, type ActionFunctionArgs } from '@remix-run/node';
import { z } from 'zod';
import { muteConversation } from '~/modules/chat/api/mute-conversation.server';

export const MUTE_CONVERSATION_API = '/remix-api/chat/mute';

const FORM_DATA_SCHEMA = z.object({
    conversationID: z.coerce.number().int().positive(),
    isMuted: z.coerce.boolean(),
});

/**
 * API endpoint to mute/unmute a conversation. Use with the `useUpdateConversation` hook.
 * @see {@link packages/web/app/modules/chat/hooks/use-update-conversation.ts}
 */
export const action = async ({ context, request }: ActionFunctionArgs) => {
    const { logger } = context;
    const payload = await request.json();
    const result = FORM_DATA_SCHEMA.safeParse(payload);

    if (!result.success) {
        return json(null, { status: 400 });
    }

    try {
        const response = await muteConversation({
            context,
            conversationID: result.data.conversationID,
            isMuted: result.data.isMuted,
        });

        if (!response) {
            return json(null, { status: 500 });
        }

        return json({ conversation: response.conversation });
    } catch (error) {
        logger.error(`Error in ${MUTE_CONVERSATION_API}`, {
            error,
            data: result.data,
        });
        return json(null, { status: 500 });
    }
};
